<div class="modal-header">
    <h3 class="modal-title mb-0 fw-bolder">Referral List</h3>
</div>
<div class="modal-body p-0">
    <table class="table table-bordered table-striped table-sm mb-0">
        <thead class="table-primary">
            <tr>
                <th>No</th>
                <th>Code</th>
                <th>Name</th>
                <th>Mobile/Username</th>
                <th>Balance</th>
                <th>Status</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let referral of referrals; let i = index">
                <td>{{i + 1}}</td>
                <td>{{referral.code}}</td>
                <td>{{referral.name}}</td>
                <td>{{referral.mobile}}</td>
                <td>{{referral.balance}}</td>
                <td>{{referral.status}}</td>
            </tr>
            <tr *ngIf="referrals.length == 0 && !is_loading_function"><td colspan="6" class="text-center">No data found</td></tr>
            <tr *ngIf="is_loading_function"><td colspan="6" class="text-center">Loading...</td></tr>
        </tbody>
    </table>
</div>